// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"27ff9402","498":"8bad0117","703":"3620a5d8"}[chunkId] + ".chunk.js";
};